module.exports = __webpack_public_path__ + "static/media/01.30722180.png";